import { RefObject } from "react"
import * as htmlToImage from 'html-to-image'

export async function canvasExport(ref: RefObject<HTMLUListElement | HTMLDivElement>) {
    if (ref && ref.current) {
      let base64url = await htmlToImage.toJpeg(ref.current, { quality: 0.95, skipFonts: true })
        console.log("canvasExport", base64url)
      return base64url
    }
  }